import { isHonorable, isPureUltimate, isStandard } from '@merchant-backend/util'
import { buyZunXiang } from '@util'
import { inject, observer } from 'mobx-react'
import React, { Component } from 'react'
import DataCenter from '../DataCenter'
import Decoration from '../Decoration'
import FixedFooter from '../FixedFooter'
import GetCustomer from '../GetCustomer'
import Header from '../Header'
import IntelligenceRelease from '../IntelligenceRelease'
import Marketing from '../Marketing'
import Wechat from '../Wechat'
import WhoUse from '../WhoUse'

@inject('pageStore')
@observer
export default class ZunXiangPage extends Component {
  getFooterData = () => {
    let btnText = '立即开通'

    /**
     * 基础版显示立即开通
     * 标准版、旗舰版显示立即升级
     * 尊享版显示立即续费
     */
    if (isStandard() || isPureUltimate()) {
      btnText = '立即升级'
    }

    if (isHonorable()) {
      btnText = '立即续费'
    }

    return { btnText }
  }

  render() {
    const { pageStore, ...rest } = this.props
    const { btnText } = this.getFooterData()

    return (
      <div>
        <Header {...rest} />
        <IntelligenceRelease />
        <Decoration />
        <Marketing />
        <GetCustomer />
        <Wechat />
        <DataCenter />
        <WhoUse showBuy={false} />
        <FixedFooter
          price={16800}
          unit="半年"
          rightText={btnText}
          onClick={() => {
            buyZunXiang()
          }}
        />
      </div>
    )
  }
}
